import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class GlobalObjectService {
    static implementations: any = {};

    static register(typeName: string, variable: any, isOverWrite = false) {
        if ((isOverWrite || !GlobalObjectService.implementations.hasOwnProperty(typeName)) && variable !== null) {
            GlobalObjectService.implementations[typeName] = variable;
        }
    }

    constructor() {
    }

    static getVar(typeName: string, defaultValue = null) {
        if (!GlobalObjectService.implementations.hasOwnProperty(typeName)) {
            return defaultValue;
        }
        return GlobalObjectService.implementations[typeName];
    }
}

